import { create } from 'zustand';

type Method = 'sdd' | 'bopis' | 'sth';

type SelectedDeliveryMethodState = {
    method: Method;
    methodUpper: Uppercase<Method>;
    setMethod: (newMethod: Method) => void;
    resetMethod: () => void;
};

export const useSelectedDeliveryMethodStore = create<SelectedDeliveryMethodState>()((set, get) => ({
    method: 'bopis',
    methodUpper: 'BOPIS',
    setMethod: (newMethod: Method) => {
        if (get().method === newMethod) return;

        set({ method: newMethod, methodUpper: newMethod.toUpperCase() as Uppercase<Method> });
    },
    resetMethod: () => set({ method: 'bopis', methodUpper: 'BOPIS' }),
}));
